export const smq = {
  logo_image_url: 'smq/default.png',
  body_background_color: '#1f1f1f',
  button_radius: 3,
  text_font: `'Open Sans', sans-serif;`,
  title_font: `'Open Sans', sans-serif;`,
}

export const smq_borealis = {
  ...smq,
  logo_image_url: 'smq/borealis.png',
  header_height: 100,
  button_color: '#ea3440',
  button_half_border_color: '#ea3440',
  text_color: 'black',
}

export const smq_cosmodome = {
  ...smq,
  logo_image_url: 'smq/cosmodome.png',
  logo_height: 100,
  button_color: '#2b2e34',
  button_half_border_color: '#2b2e34',
  text_color: 'black',
}

export const smq_exploramer = {
  ...smq,
  logo_image_url: 'smq/exploramer.png',
  logo_height: 100,
  button_color: '#114786',
  button_half_border_color: '#114786',
}

export const smq_jardinsdemetis = {
  ...smq,
  logo_image_url: 'smq/jardinsdemetis.png',
  logo_height: 60,
  button_color: '#2d9fd8',
  button_half_border_color: '#2d9fd8',
}

export const smq_musee_armand_bombardier = {
  ...smq,
  logo_image_url: 'smq/musee-armand-bombardier.png',
  logo_height: 80,
  button_color: '#fcc514',
  button_half_border_color: '#fcc514',
}

export const smq_musee_charlevoix = {
  ...smq,
  logo_image_url: 'smq/musee-charlevoix.png',
  logo_height: 100,
  button_color: '#ffcc33',
  button_half_border_color: '#ffcc33',
}

export const smq_musee_fjord = {
  ...smq,
  logo_image_url: 'smq/musee-fjord.png',
  logo_height: 70,
  button_color: '#2b2e34',
  button_half_border_color: '#2b2e34',
}

export const smq_musee_maritime = {
  ...smq,
  logo_image_url: 'smq/musee-maritime.png',
  logo_height: 100,
  button_color: '#0088ce',
  button_half_border_color: '#0088ce',
}

export const smq_musee_nature_sciences = {
  ...smq,
  logo_image_url: 'smq/musee-nature-sciences.png',
  logo_height: 100,
  button_color: '#1f89ca',
  button_half_border_color: '#1f89ca',
}

export const smq_musee_pop = {
  ...smq,
  logo_image_url: 'smq/musee-pop.png',
  logo_height: 100,
  button_color: '#6d8bb3',
  button_half_border_color: '#6d8bb3',
}

export const smq_musee_regional_rimouski = {
  ...smq,
  logo_image_url: 'smq/musee-regional-rimouski.png',
  button_color: '#d72927',
  button_half_border_color: '#d72927',
}

export const photofamille = {
  ...smq,
  header_background_color: '#00a6e9',
  logo_image_url: 'smq/photofamille/famille-bg.png',
  header_full_height: true,

  button_color: '#1b495a',
  button_text_uppercase: true,
  button_radius: 3,
  button_half_border_color: 'transparent',

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}
